import { useMemo } from 'react'

type Player = {
	id: string
	color: string
	label: string
}

type PlayerInfo = {
	color: string
	label: string
}

/**
 * Creates a map of player IDs to their color and label info.
 * Memoized for performance to avoid recreating the map on every render.
 *
 * @param players - Array of player objects with id, color, and label
 * @returns Map of player ID to { color, label }
 *
 * @example
 * const playerInfo = usePlayerInfoMap(players)
 * const info = playerInfo.get(playerId)
 * if (info) {
 *   console.log(info.color, info.label)
 * }
 */
export function usePlayerInfoMap(players: Player[]): Map<string, PlayerInfo> {
	return useMemo(() => {
		const map = new Map<string, PlayerInfo>()
		for (const player of players) {
			map.set(player.id, { color: player.color, label: player.label })
		}
		return map
	}, [players])
}
